export const tasksEmptyMessages = [
  {
    title: '💤 Завдань поки немає',
    description: 'Можливо, час запланувати щось важливе?',
  }
];

export const archivedTasksEmptyMessages = [
  {
    title: '🗂 Архів ще порожній',
    description: 'Усі завершені справи потраплятимуть сюди. Поки що нічого не завершено — але все попереду!',
  }
];
